import Button from "@shared/v2/Button";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import { useCurrentUser, useFeatureFlags } from "../../reducers/layoutReducer/selectors";

interface InfoContainerProps {
  action?: React.ReactNode;
  description: string;
  href?: string;
  title: string;
}

const InfoContainer: React.FC<InfoContainerProps> = ({ action, description, href, title }) => (
  <div className="tw-p-[16px] tw-rounded-[8px] tw-border-solid tw-border-[1px] tw-border-gray-10 tw-flex tw-justify-between tw-items-center">
    <div className="tw-flex tw-flex-col tw-gap-[4px]">
      {/* @ts-expect-error props */}
      <Typography variant="subtitle-s">{title}</Typography>
      {/* @ts-expect-error props */}
      <Typography variant="body-s">{description}</Typography>
    </div>
    <div>
      {href && (
        // @ts-expect-error props
        <Button
          schema="tertiary"
          className="tw-flex tw-items-center tw-gap-[4px]"
          onClick={() => window.open(href, "_blank")}
        >
          Read Article <ArrowUpRightFromSquareSolidV6 />
        </Button>
      )}
      {action}
    </div>
  </div>
);

interface ResourcesSettingsModalProps {
  accountProduct?: { id: number; status: string };
  show: boolean;
  onClose: () => void;
  onOpenTutorial: () => void;
  onCancel: () => void;
}

const ResourcesSettingsModal: React.FC<ResourcesSettingsModalProps> = ({
  accountProduct,
  show,
  onClose,
  onOpenTutorial,
  onCancel,
}) => {
  const {
    account: { isPlace },
  } = useCurrentUser() as { account: { isPlace: boolean } };
  const featureFlags = useFeatureFlags() as { opportunitiesAddonPurchase?: boolean };

  return (
    <Modal
      show={show}
      onHide={onClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px] tw-overflow-hidden"
    >
      {/* @ts-expect-error props */}
      <Modal.Header title={`Resources${isPlace ? "" : " & Settings"}`} closeButton />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[8px] tw-overflow-auto">
        {/* @ts-expect-error props */}
        <Typography variant="subtitle-m-bold">Training & Resources</Typography>
        <InfoContainer
          title="Learn about Expireds"
          description="Tips for working Expired properties in Opportunities"
          href="https://www.brivityknowledge.com/docs/expired-listing-opportunities"
        />
        <InfoContainer
          title="Learn about FSBO's"
          description="Tips for working FSBO properties in Opportunities"
          href="https://www.brivityknowledge.com/docs/fsbo-listing-opportunities"
        />
        <InfoContainer
          title="Learn about Pre-Foreclosure"
          description="Tips for working Pre-Foreclosure properties in Opportunities"
          href="https://www.brivityknowledge.com/docs/pre-forclosure-opportunities"
        />
        {/* TODO: When the link/trigger is known implement these */}
        {/* <InfoContainer
        title="Overview & FAQ"
        description="Best practices and frequently asked questions"
        href="about:blank"
      /> */}
        <InfoContainer
          title="View Tutorial Again"
          description="A quick overview of the Opportunities System"
          action={
            // @ts-expect-error props
            <Button
              schema="secondary"
              onClick={() => {
                onClose();
                onOpenTutorial();
              }}
            >
              View Tutorial
            </Button>
          }
        />
        {!isPlace && featureFlags.opportunitiesAddonPurchase && (
          <>
            {/* @ts-expect-error props */}
            <Typography className="tw-mt-[16px]" variant="subtitle-m-bold">
              Subscription Management
            </Typography>
            {accountProduct?.status === "canceled" ? (
              // @ts-expect-error props
              <Typography className="!tw-text-gray-50">
                Your cancellation request is being processed - you will receive an email confirmation in a
                couple of days once it’s successfully processed.
              </Typography>
            ) : (
              // @ts-expect-error props
              <Typography className="!tw-text-gray-50">
                Opportunities is a fixed price add-on. To cancel your subscription,{" "}
                <a className="tw-underline tw-text-gray-50 hover:tw-text-gray" href="#" onClick={onCancel}>
                  click here
                </a>
                .
              </Typography>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-end">
        {/* @ts-expect-error props */}
        <Button size="medium" onClick={onClose}>
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResourcesSettingsModal;
